/**
 * auth-token-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Message } from "../general/message";
import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

/**
 * TODO
 */
export class AuthTokenRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_AUTH_TOKEN;
	public static tag : MessageTag = MessageTag.REQ_AUTH_TOKEN;

  public verifyReply (reply : Message) : boolean
  {
    return Message.isA(reply, MessageTag.RSP_AUTH_TOKEN);
  }

  /**
   * Construct a new {@link SubjectContextRefreshMessage}.
   */
  constructor ()
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/auth/auth-token-request.ts